var $f76cb41aa1b2fad1$exports = {};
$f76cb41aa1b2fad1$exports = {
    "backButton": (args)=>`Povratak na ${args.prevMenuButton}`,
    "moreActions": `Dodatne radnje`,
    "unavailable": `Nije dostupno, pro\u{161}irite za detalje`
};


export {$f76cb41aa1b2fad1$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
